
const app = {
    name: "Rock calculator",
    updateDate: new Date(2020, 10, 5),
    version: "1.0.1"
}

export default app;